import { useSelector } from 'react-redux';
import { ReactComponent as ZenModeIcon } from 'images/icons/zen-mode-icon.svg';
import { ReactComponent as RefreshIcon } from 'images/icons/zen-mode-refresh-icon.svg';
import { selectGridMode } from '../slice';
import { GRID_MODELS } from '../grid/constants';
import { StyledText, StyledZenModeWrapper } from './style';

export const ZenMode = () => {
  const gridMode = useSelector(selectGridMode);
  return (
    <StyledZenModeWrapper isZenMode={gridMode === GRID_MODELS.Zen}>
      <ZenModeIcon className="zen-mode-icon" />
      <StyledText>Zen Mode</StyledText>
      <RefreshIcon className="zen-refresh-icon" />
    </StyledZenModeWrapper>
  );
};
